/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function FileSource(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M18 10V7.828C18 7.298 17.789 6.789 17.414 6.414L14.586 3.586C14.211 3.211 13.702 3 13.172 3H6C4.895 3 4 3.895 4 5V19C4 20.105 4.895 21 6 21H10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 8H14C13.448 8 13 7.552 13 7V3L18 8Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.95 17.4996L10.95 17.4997C10.9507 20.5653 13.435 23.0497 16.4997 23.05H16.4997C19.5653 23.0493 22.0497 20.5653 22.05 17.4997C22.0497 14.435 19.5653 11.9507 16.4997 11.95L16.4996 11.95C13.435 11.9507 10.9507 14.435 10.95 17.4996ZM16.9675 22.0802C16.9414 22.1019 16.9169 22.1216 16.8938 22.1397V20.3007H18.2919C18.1197 20.6793 17.924 20.9982 17.7296 21.2629C17.4507 21.6415 17.1721 21.9098 16.9675 22.0802ZM12.1911 19.5125C11.9575 19.0138 11.8079 18.4695 11.7595 17.8941H13.372C13.3979 18.4911 13.4789 19.0311 13.6027 19.5125H12.1911ZM16.8938 14.701V12.8621C17.2308 13.1299 17.8397 13.7092 18.2905 14.701H16.8938ZM16.8938 15.4878H18.5832C18.7194 15.9561 18.8117 16.4961 18.8415 17.1066H16.8938V15.4878ZM16.0321 12.9202C16.0585 12.8984 16.0831 12.8786 16.1062 12.8604V14.7007H14.7078C14.8803 14.3217 15.0757 14.0024 15.2701 13.7377C15.5492 13.3585 15.8275 13.0909 16.0322 12.9201L16.0002 12.8817L16.0321 12.9202ZM16.1062 15.4878V17.1066H14.1598C14.1898 16.4934 14.2843 15.9562 14.4215 15.4878H16.1062ZM13.6027 15.4878C13.4789 15.9696 13.3979 16.5098 13.372 17.1066H11.7594C11.8075 16.5314 11.9569 15.9865 12.1905 15.4878H13.6027ZM14.4165 19.5125C14.2803 19.0445 14.188 18.5046 14.1581 17.8941H16.1062V19.5125H14.4165ZM16.1062 20.3003V22.1386C15.7694 21.8711 15.1602 21.2921 14.7095 20.3003H16.1062ZM16.8938 19.5125V17.8941H18.8398C18.8099 18.5069 18.7154 19.0442 18.5784 19.5125H16.8938ZM19.3973 19.5125C19.5207 19.0311 19.6018 18.4911 19.628 17.8941H21.2399C21.1918 18.4692 21.0421 19.0138 20.8085 19.5125H19.3973ZM19.628 17.1066C19.6018 16.5096 19.521 15.9696 19.397 15.4878H20.8089C21.0425 15.9865 21.1921 16.5315 21.2399 17.1066H19.628ZM18.193 13.0539C19.062 13.3853 19.808 13.9618 20.3467 14.7007H19.1412C18.8702 14.0097 18.5264 13.4654 18.193 13.0539ZM13.8588 14.7007H12.6533C13.1923 13.9618 13.9383 13.3852 14.8068 13.0538C14.4736 13.4656 14.1295 14.0099 13.8588 14.7007ZM14.8061 21.9455C13.9383 21.6144 13.193 21.0385 12.6543 20.3003H13.8591C14.1295 20.9901 14.473 21.534 14.8061 21.9455ZM19.1408 20.3003H20.3457C19.807 21.0386 19.0616 21.6145 18.1936 21.9455C18.5267 21.534 18.8701 20.9901 19.1408 20.3003Z"
        fill={color}
        stroke={color}
        strokeWidth="0.1"
      />
    </svg>
  );
}

FileSource.defaultProps = {
  color: "currentColor",
  size: 24,
};

FileSource.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
